// Utilitaire : compteur de scans réussis persistent en localStorage.
// Utilisé par LoveColobongoNudge pour ne se déclencher qu'après le 2e scan.

const SCAN_COUNT_KEY = 'colobongo_scan_count';

/**
 * Lit le nombre de scans réussis depuis localStorage.
 * Retourne 0 si absent ou invalide.
 */
export function getScanCount() {
  if (typeof window === 'undefined') return 0;
  try {
    const raw = window.localStorage.getItem(SCAN_COUNT_KEY);
    const n = parseInt(raw, 10);
    return Number.isFinite(n) && n >= 0 ? n : 0;
  } catch {
    return 0;
  }
}

/**
 * Incrémente le compteur de scans réussis.
 * Doit être appelé après chaque analyse IA réussie dans ScanPage.
 */
export function incrementScanCount() {
  if (typeof window === 'undefined') return;
  try {
    const current = getScanCount();
    window.localStorage.setItem(SCAN_COUNT_KEY, String(current + 1));
  } catch {
    // best-effort : localStorage peut être restreint
  }
}

export const SCAN_COUNT_STORAGE_KEY = SCAN_COUNT_KEY;
